import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const SidebarTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "var(--tool-tip-bg-color)",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "var(--tool-tip-bg-color)",
      color: "var(--tool-tip-text-color)"
    },
}));

export default SidebarTooltip